import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Replace non-breaking spaces with regular spaces so HTML wraps properly */
export function sanitizeHtml(html: string): string {
  return html.replace(/&nbsp;/g, " ").replace(/\u00A0/g, " ");
}

/** Format a date string or Date object to DD-MM-YYYY */
export function formatDateDMY(value: string | Date | null | undefined): string {
  if (!value) return "—";
  const d = typeof value === "string" ? new Date(value) : value;
  if (isNaN(d.getTime())) return "—";
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
}

/** Format a date string or Date object to DD-MM-YYYY hh:mm AM/PM */
export function formatDateTimeDMY(value: string | Date | null | undefined): string {
  if (!value) return "—";
  const d = typeof value === "string" ? new Date(value) : value;
  if (isNaN(d.getTime())) return "—";
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  let hours = d.getHours();
  const minutes = String(d.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
}

/**
 * Screening notes are only shown to users in the HR department.
 * Accepts both spellings in use ("Human Resource" lookup value, "Human Resources").
 */
export function isHrDepartment(department: string | null | undefined): boolean {
  const d = department?.trim().toLowerCase();
  return d === "human resource" || d === "human resources";
}
